import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './blocks/App/App';

import './setLang';

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('#app');
    if (container) {
        const root = createRoot(container);
        root.render(<App />);
    }
});
